// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__GPay1","sendOtp":"AuthorizeToLogin_sendOtp__3BOqy"};